export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'

export const LOGOUT_USER = 'LOGOUT_USER'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'

export const GET_ANSWER_VIDEO = 'GET_ANSWER_VIDEO'
export const GET_ANSWER_VIDEO_SUCCESS = 'GET_ANSWER_VIDEO_SUCCESS'

export const USER_ERROR = 'USER_ERROR'